import { postAdminOrganisation, postAdminOrganisationByOrganisationIdGroup, invite_user_to_organisation } from '@modv/sdk'
// eslint-disable-next-line no-unused-vars
import { Notification } from 'element-ui'

const state = {
  showNewEntityModal: false,
  showDeleteModal: false,
  entityType: '',
  entityName: ''
}
const getters = {}
const mutations = {
  ON_CHANGE_MODAL: (state, res) => {
    state.showNewEntityModal = res.visible
    state.entityType = res.entityType || state.entityType
    state.entityName = ''
  },
  SET_ENTITY_NAME: (state, newValue) => {
    state.entityName = newValue
  }
}
const actions = {
  onChangeModal({ commit }, params) {
    commit('ON_CHANGE_MODAL', params)
  },
  setEntityName: ({ commit }, params) => {
    commit('SET_ENTITY_NAME', params.value)
  },

  async createOrganisation({ commit, dispatch }, params) {
    const res = await postAdminOrganisation({ name: params.name })

    dispatch(
      'home/getOrganisations',
      {
        organisation: res.data
      },
      {
        root: true
      }
    )

    commit('ON_CHANGE_MODAL', { visible: false })

    if (res.status === 200) {
      Notification.success('Organization created!')
    } else {
      Notification.error('Failed to create organisation.')
    }
  },
  async createGroup({ commit, dispatch }, params) {
    const res = await postAdminOrganisationByOrganisationIdGroup({
      organisationId: params.organisationId,
      name: params.name
    })
    dispatch(
      'organisation/getGroups',
      {
        organisationId: params.organisationId,
        groups: res.data
      },
      {
        root: true
      }
    )
    commit('ON_CHANGE_MODAL', { visible: false })
    if (res.status === 200) {
      Notification.success('Group created!')
    } else {
      Notification.error('Failed to create group.')
    }
  },
  async inviteUsers({ commit, dispatch }, params) {
    const res = await invite_user_to_organisation({
      organisationId: params.organisationId,
      pendingAdminUsers: params.pendingAdminUsers,
      pendingUsers: params.pendingUsers
    })
    dispatch(
      'organisation/getUsers',
      {
        organisationId: params.organisationId,
        pendingAdminUsers: res.data.pendingAdminUsers,
        pendingUsers: res.data.pendingUsers
      },
      {
        root: true
      }
    )
    commit('ON_CHANGE_MODAL', { visible: false })
    if (res.status === 200) {
      Notification.success('User(s) Invited!')
    } else {
      Notification.error('Unable to invite user(s).')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
